import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../api/store";
import { TATItems } from "./policy-tat.interface";

export type policyTATModalType = null | "policyDataPageGCLIP";
export type EditableTATField =
    | "tat"
    | "reckoning_date"
    | "mode_of_communication";

export interface PolicyTATState {
    policyTATModals: null;
    isEditingTAT: boolean;
    tatItems: null| TATItems[];
}

const initialState: PolicyTATState = {
    policyTATModals: null,
    isEditingTAT: false,
    tatItems: null,
};

const policyTATSlice = createSlice({
    name: "policyTATSlice",
    initialState,
    reducers: {
        resetPolicyTATState: () => initialState,

        setIsEditingTAT: (state,action: PayloadAction<boolean>) => {
            state.isEditingTAT = action.payload;
        },

        setTATItems: (state, action: PayloadAction<TATItems[]> ) => {
            state.tatItems = action.payload;
        },
        onChangeTATItem: (state, action: PayloadAction<{ id: number; field: EditableTATField, value: string; }>) => {
            const { id, field, value } = action.payload;

            const item = state.tatItems?.find((item) => item.tat_id === id || item.sort_order === id);
            if (!item) return;
            item[field] = value;
        },
        resetTATEditing: (state) => {
            state.isEditingTAT = false;
            state.tatItems = null;
        },
    },
});

export const {
    resetPolicyTATState,
    
    setIsEditingTAT,

    setTATItems,
    onChangeTATItem,
    resetTATEditing
} = policyTATSlice.actions;

export default policyTATSlice.reducer;

export const selectIsEditingTAT = (state: RootState) => state.policyTATSlice.isEditingTAT;
export const selectPolicyTATModalType = (state: RootState) => state.policyTATSlice.policyTATModals;
export const selectTATItems = (state: RootState) => state.policyTATSlice.tatItems;

// dispatch(onChangeTATItem({ id, field: "tat", value: e.target.value, }))